import { LEVEL_IDS, opFor, parseLevelId, type LevelId, type WorldId } from './ids';

/** Threat of an operation (GDD §13.2, MISIONES). The interface shows it in words from the catalog. */
export type Threat = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';

export interface MissionInfo {
  readonly levelId: LevelId;
  readonly op: string;
  readonly world: WorldId;
  readonly threat: Threat;
}

const THREATS: readonly Threat[] = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];

/**
 * Threat by world (1 Baja, 2 Media, 3 Alta, 4 Crítica) and one step more on the boss level, capped at
 * Crítica (GDD §10.1).
 */
export function threatOf(id: LevelId): Threat {
  const { world, level } = parseLevelId(id);
  return THREATS[Math.min(world - 1 + (level === 3 ? 1 : 0), THREATS.length - 1)]!;
}

/** The 12 operations of the campaign in order, whether or not their LevelDef exists yet. */
export const MISSIONS: readonly MissionInfo[] = LEVEL_IDS.map((levelId) => ({
  levelId,
  op: opFor(levelId),
  world: parseLevelId(levelId).world,
  threat: threatOf(levelId),
}));
